(function () {
    var images = document.querySelectorAll(".scale-up");
    var update = function () {
        // find the middle point of the browser
        var midBrowser = window.innerHeight / 2;
        // loop over each image
        images.forEach(function (img) {
            // get the 'rectangle' positions of each image
            var _a = img.getBoundingClientRect(), top = _a.top, height = _a.height;
            // find where the middle of the image is within the browser
            var midImg = top + height / 2;
            // compare the middle of browser to the middle of each image
            var diff = midImg - midBrowser;
            // work out a scale
            // can't be larger than 100%
            // 1000 is for how quickly to change scale
            var scale = Math.min(1, 1 - diff / 4000);
            // change the images
            /* @ts-ignore */
            img.style.transform = "scale(" + scale + ")";
        });
    };
    // run on load
    update();
    // and on scroll
    window.addEventListener("scroll", function () {
        update();
    });
    // and on page resize
    window.addEventListener("resize", function () {
        update();
    });
})();
